<template>
  <el-dialog custom-class="system_manager_dialog"
             :title="isFive ? '批量添加五人制': '批量添加十一人制'"
             :visible.sync="isShow"
             :close-on-click-modal="false"
             width="450px">
    <div class="teachers_add">
      <el-upload
          class="upload-component"
          ref="uploadFile"
          action="/api/user/batch_teacher_excel.json"
          :headers="fileUpHeaders"
          :data="fileUpParam"
          :before-upload="beforeUpload"
          :on-success="uploadSuccess"
          :on-remove="removeFile"
          :limit="limitNum"
      >
        <el-button type="primary">点击上传</el-button>
      </el-upload>
      <p class="upload-tips">
        <span>请上传 excel 文件 或&nbsp;</span>
        <a :href="loadExcelUrl"
           download="">下载模板</a>
        <span>&nbsp;编辑后上传</span>
      </p>
      <p class="tips"
         v-if="showUploadTips">
        <span>共{{uploadResult.errorNum+uploadResult.trueNum}}条信息，其中{{uploadResult.errorNum}}条信息有误，有误信息不可导入请</span>
        <a class="errDownload"
           :href="uploadResult.errorUrl"
           download="">《下载错误信息》</a>
        <span>修改后重新上传~</span>
      </p>
      <div class="btnWrap"
           v-if="showImportBtn">
        <el-button class="importBtn"
                   type="primary"
                   @click="importExcel">立即导入</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
  import {storageData} from "@/assets/js/storage";
  import {addManyTeacher} from "@/api/system_manager/api";
  export default {
    name: "teas-add",
    props: ["visible", 'isFive'],
    data() {
      return {
        showUploadTips: false,
        uploadResult: {},
        fileUpParam: {
          excel: null,
        },
        limitNum: 1,
        fileUpHeaders: {'X-Token': storageData.getToken(),"X-UserType":storageData.getUserType()},
        showImportBtn: false,
        loadExcelUrl: "/uploads/import_tpl/批量添加讲师模板.xlsx",
      };
    },
    computed: {
      isShow: {
        get(){
          return this.visible;
        },
        set(bool){
          // 参数1：是否显示弹窗
          // 参数2：是否点击关闭按钮
          this.reset();
          this.$emit("hideUpload", bool, false);
        }
      },
    },

    created() {
      this.loadExcelUrl = this.isFive ? '/uploads/import_tpl/五人制批量添加讲师模板.xlsx' : '/uploads/import_tpl/批量添加讲师模板.xlsx';
      // console.warn('请修改模板文件的路径，当前默认十一人制模板')
    },
    methods: {
      beforeUpload(file) {
        const reg = /^.*\.(xls|xlsx)$/i;
        if(!reg.test(file.name)) {
          this.$message.error("请上传Excel文件！");
          return false;
        }
        if(file.size > 20*1024*1024) {
          this.$message.error("文件大小不能超过20M!");
          return false;
        }
        this.$set(this.fileUpParam, "excel", file);
      },
      removeFile() {
        this.showUploadTips = false;
        this.showImportBtn = false;
      },
      uploadSuccess(res) {
        // console.log(res);
        if(Number(res.status) === 0) {
          if(Number(res.result.errorNum) !== 0) {
            this.showUploadTips = true;
            this.showImportBtn = false;
          }else{
            this.showUploadTips = false;
            this.showImportBtn = true;
          }
          this.uploadResult = res.result;
        }else{
          this.$message.error(res.msg);
          this.reset();
        }
      },
      importExcel() {
        // console.log(this.uploadResult.trueUrl);
        addManyTeacher({trueUrl: this.uploadResult.trueUrl})
          .then((res)=>{
            // console.log(res);
            if(Number(res.data.status) === 0) {
              this.$emit("hideUpload", false, true);
              this.reset();
            }else{
              this.$message.error(res.data.msg);
            }
          })
          .catch((err)=>{
            console.error(err);
          });
      },
      reset() {
        this.showUploadTips = false;
        this.showImportBtn = false;
        this.$refs.uploadFile.clearFiles();
      },
    }
  }
</script>

<style lang="stylus" scoped>
  @import '~@/assets/css/variable';
  .teachers_add {
    position: relative;
    padding: 0 5% 5%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .upload-tips {
      margin: 10px 0 0;
      a {
        color: $color_suc;
      }
    }
    .upload-component {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    .tips {
      margin: 30px 0 0;
      color: $color_err;
      font-size: $font_size_medium;
      .errDownload {
        color: $color_primary;
      }
    }
    .btnWrap {
      text-align: center;
      .importBtn {
        margin: 30px 0 0;
      }
    }
  }
</style>